import React from "react";
import "./Premium_Quality.css";

const Premium_Quality = () => {
  return (
    <section className="Premium_Quality">
      <div className="container">
        <div className="big_img_div">
          <img
            src="/assets/images/home/premium_quality/img1.png"
            className="inner_img"
          />
        </div>
        <div className="content_holder">

          <p className="title_text">Premium Quality with Luxurious Feel</p>
          <div className="quote_img_div">
            <img
              src="/assets/images/home/premium_quality/quote.png"
              className="quote_img"
            />
          </div>
          <p className="bcoz_text">Because </p>
          <p className="subtext">
            we spend one-third of our lives asleep, sleep quality is a vital
            factor in our overall well-being.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Premium_Quality;
